import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const API = process.env.REACT_APP_BACKEND_URL;

export const RouteTracker = () => {
  const location = useLocation();
  useEffect(() => {
    try {
      let sid = sessionStorage.getItem("mk_sid");
      const first = !sid;
      if (!sid) {
        sid = Math.random().toString(36).slice(2) + Date.now().toString(36);
        sessionStorage.setItem("mk_sid", sid);
      }
      const path = location.pathname;
      const seenKey = `mk_seen_${path}`;
      if (sessionStorage.getItem(seenKey)) return;
      sessionStorage.setItem(seenKey, "1");
      const utm = new URLSearchParams(location.search).get("utm_source") || null;
      const storeMatch = path.match(/^\/store\/([^/]+)/);
      const prodMatch = path.match(/^\/product\/([^/]+)/);
      fetch(`${API}/api/track/visit`, {
        method: "POST",
        headers: { ...(localStorage.getItem("mk_sandbox") === "1" ? { "X-Sandbox": "1" } : {}), "Content-Type": "application/json" },
        body: JSON.stringify({
          path, referrer: document.referrer || null, utm_source: utm, session_id: sid, first,
          store_slug: storeMatch ? storeMatch[1] : null,
          product_slug: prodMatch ? prodMatch[1] : null,
        }),
      }).catch(() => {});
    } catch {}
  }, [location.pathname, location.search]);
  return null;
};
